import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { setQuoteTestData } from 'src/store/slice/quote/slice';
import {
  setPaymentTestData,
  setCreatedPaymentAddressTestData,
  setWidgetLanguageTestData,
} from 'src/store/slice/payment/slice';

import { useCustomSearchParams } from 'src/hook';

const useDemo = () => {
  const dispatch = useDispatch();

  const { isDemo } = useCustomSearchParams();

  useEffect(() => {
    if (isDemo) {
      dispatch(setPaymentTestData());
      dispatch(setWidgetLanguageTestData());
      dispatch(setCreatedPaymentAddressTestData());
      dispatch(setQuoteTestData());
    }
  }, [isDemo]);

  return null;
};

export { useDemo };
